import Api from "../helpers/api";

export const vratObrazok = async (subor, nazovSuboru) => {
  try {
    const response = await Api.get(`/api/v1/smartmap/file/${subor}`);
    return response.data ? response.data : false;
  } catch (error) {
    return false;
  }
};

export const vratSubor = async (subor, nazovSuboru) => {
  try {
    const response = await Api.get(
      `/api/v1/smartmap/file/${subor}`,
      {},
      nazovSuboru
    );
    return response.data ? response.data : false;
  } catch (error) {
    return false;
  }
};
